import React, { isValidElement } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { findChildByType } from '../../utils/findChildByType/findChildrenByType.es.js';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Flex } from '../Flex/Flex.es.js';
import { NavBarBrand } from './NavBarBrand.es.js';
import { NavBarMenu } from './NavBarMenu.es.js';
import { NavBarDrawer as NavBarDrawer$1 } from './NavBarDrawer.es.js';
import { NavBarSubMenu } from './NavBarSubMenu.es.js';
import { NavBarDrawer, NavBar as NavBar$2, Divider } from './styled.es.js';
import { NavBarProvider } from './NavBarContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NavBar = (_a) => {
  var _b = _a, { children, justify, menuLabel, collapseBelow = "lg" } = _b, props = __objRest(_b, ["children", "justify", "menuLabel", "collapseBelow"]);
  const isMobile = useBreakpoint(collapseBelow);
  const brand = findChildByType(children, NavBarBrand);
  const menuNode = findChildByType(children, NavBarMenu);
  const menu = isValidElement(menuNode) && React.cloneElement(menuNode, { justify });
  const submenu = findChildByType(children, NavBarSubMenu);
  return /* @__PURE__ */ React.createElement(NavBarProvider, {
    value: { isMobile }
  }, isMobile ? /* @__PURE__ */ React.createElement(NavBarDrawer, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Flex, {
    alignItems: "center"
  }, /* @__PURE__ */ React.createElement(NavBarDrawer$1, {
    brand,
    menu,
    menuLabel
  }), brand), submenu) : /* @__PURE__ */ React.createElement(NavBar$2, __spreadValues({}, props), brand, /* @__PURE__ */ React.createElement(Divider, null), menu, submenu));
};
NavBar.displayName = "NavBar";
var NavBar$1 = Object.assign(NavBar, {
  Brand: NavBarBrand,
  Menu: NavBarMenu,
  SubMenu: NavBarSubMenu
});

export { NavBar$1 as default };
//# sourceMappingURL=NavBar.es.js.map
